import React, {useEffect} from 'react';
import {Button, Form, Input, InputPicker} from "rsuite";
import {useFormik} from "formik";
import {rsuiteInputOnchangeFormikHandler, rsuiteInputPickerOnchangeFormikHandler } from "util/Helper";
import {validationSchema} from "./validatonSchemas";

const SingleBed = (props) => {
    const {showBin, getData, index, onRemove, formSubmit, setFormSubmit, sections, setSections} = props;
    const removeCurrentBed = () => onRemove(index);

    const formHandler = useFormik({
        initialValues: {
            sectionName: { label: '', value: ''},
            roomName: '',
            bedName: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            values.sectionName = values.sectionName.value;
            getData(index, values);
        },
    })

    const formikOnInputChange = rsuiteInputOnchangeFormikHandler(formHandler.handleChange);
    const formikOnInputPickerChange = rsuiteInputPickerOnchangeFormikHandler(formHandler.handleChange, 'sectionName', sections, setSections);

    useEffect(() => {
        if(!formSubmit) return;

        formHandler.validateForm().then((validationErrors) => {
            if(Object.keys(validationErrors).length) {
                setFormSubmit(false);
            }

            formHandler.submitForm()
        })
    }, [formSubmit]);

    return (
        <div className='beds-list__single-bed'>
            <Form className='beds-list__add-form' layout='inline'>
                <Form.Group controlId="section" className='beds-list__input-group'>
                    <Form.Control
                            className={'beds-list__input'}
                            accepter={InputPicker}
                            creatable
                            data={sections}
                            name="sectionName"
                            placeholder='Section name'
                            value={formHandler.values.sectionName.value}
                            onChange={formikOnInputPickerChange}
                            errorMessage={formHandler.touched.sectionName && formHandler.errors.sectionName ? "Section field is required and cannot includes special characters except dash and underscore" : null}
                        />
                </Form.Group>

                <Form.Group controlId="room" className='beds-list__input-group'>
                    <Form.Control
                        className={'beds-list__input'}
                        accepter={Input}
                        type='text'
                        name='roomName'
                        placeholder='Room'
                        onChange={formikOnInputChange}
                        value={formHandler.values.roomName}
                        errorMessage={formHandler.touched.roomName && formHandler.errors.roomName ? formHandler.errors.roomName : null}
                    />
                </Form.Group>

                <Form.Group controlId="room" className='beds-list__input-group'>
                    <Form.Control
                        className={'beds-list__input'}
                        accepter={Input}
                        type='text'
                        name="bedName"
                        placeholder='Bed (optional)'
                        onChange={formikOnInputChange}
                        value={formHandler.values.bedName}
                        errorMessage={formHandler.touched.bedName && formHandler.errors.bedName ? formHandler.errors.bedName : null}
                    />
                </Form.Group>
                {
                    showBin &&
                    <Button appearance="subtle" className='beds-list__button' onClick={removeCurrentBed}>
                        <span className='btn-bin' />
                    </Button>
                }
            </Form>
        </div>
    );
};

SingleBed.defaultProps = {
    formSubmit: false,
    showBin: false,
    getData: (data) => console.log(data),
    index: 0,
    onRemove: (data) => console.log(data),
    sections: []
}


export default SingleBed;